import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobDisabledModule, MobSystemErrorTip } from '../../lib';

function DisabledModule(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <>
      <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/disabled`}>
        {
          <MobDisabledModule weId={`${props.weId || ''}_kj0za7`} />
        }
      </Route>
      <Route weId={`${props.weId || ''}_zuk73q`} exact path={`${parentPath}/mobile/uk/disabledmoduletip`}>
        {
          <MobDisabledModule weId={`${props.weId || ''}_r2plci`} />
        }
      </Route>
      <Route weId={`${props.weId || ''}_zuk73q`} exact path={`${parentPath}/mobile/uk/systemerrortip`}>
        {
          <MobSystemErrorTip weId={`${props.weId || ''}_t6ru7n`} />
        }
      </Route>

    </>
  )
}

export default withRouter(DisabledModule);